module.exports = __webpack_public_path__ + "img/3194ba4e44adcfce5c39afc643824aa2.png";